import Icon from '@/components/ui/AppIcon';

const ProgressOverview = () => {
  const stats = [
    { id: 'stat_completion', label: 'Overall Completion', value: '78%', icon: 'ChartPieIcon', color: 'bg-primary/10 text-primary' },
    { id: 'stat_mastered', label: 'Topics Mastered', value: '12/24', icon: 'AcademicCapIcon', color: 'bg-success/10 text-success' },
    { id: 'stat_streak', label: 'Study Streak', value: '7 days', icon: 'FireIcon', color: 'bg-warning/10 text-warning' },
    { id: 'stat_accuracy', label: 'Average Accuracy', value: '84%', icon: 'CheckCircleIcon', color: 'bg-accent/10 text-accent' },
  ]

  return (
    <section>
      <div className="mb-4 sm:mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">Welcome Back, Student!</h1>
        <p className="text-sm sm:text-base text-muted-foreground">Here's your aviation study progress</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {stats.map((stat) => (
          <div key={stat.id} className="bg-card rounded-2xl p-4 sm:p-6 border border-border">
            <div className={`w-10 h-10 sm:w-12 sm:h-12 ${stat.color} rounded-xl flex items-center justify-center mb-3 sm:mb-4`}>
              <Icon name={stat.icon as any} size={20} className="sm:w-6 sm:h-6" />
            </div>
            <div className="text-2xl sm:text-3xl font-bold text-foreground mb-1">{stat.value}</div>
            <div className="text-xs sm:text-sm text-muted-foreground">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default ProgressOverview